const baseurl = "https://api-ashiq352.herokuapp.com"
// const baseurl = "http://127.0.0.1:8000"
export const urls = {
    api: `${baseurl}/api/`,
    contact: `${baseurl}/api/contact/`,
    project_request: `${baseurl}/api/project_request/`,
    token: `${baseurl}/api/token/`,
    signin: `${baseurl}/api/user/signin/`
}
